import VideoEnableJsFilter from "./video-enable-js.filter";
import VideoManagerDirective from "./video-manager.directive";
import VideoProvidersFactory from "./video-providers.factory";

export default function VideoWrapper(moduleName) {
    VideoEnableJsFilter(moduleName);
    VideoManagerDirective(moduleName);
    VideoProvidersFactory(moduleName);
}